import { Stack, Text } from '@chakra-ui/react'

import Collapsible from '@/components/UI/Collapsible'

import type { FaqItem } from './types'

function FAQItem({
  item,
  collapsible = false,
}: {
  item: FaqItem
  collapsible?: boolean
}): JSX.Element {
  const { question, answer } = item
  const header = (
    <Text fontSize="20px" fontWeight="bold" as="h4">
      {question}
    </Text>
  )
  const answerElement = typeof answer === 'string' ? <Text>{answer}</Text> : answer()

  return collapsible ? (
    <Collapsible title={header} body={() => answerElement} />
  ) : (
    <Stack direction="column" spacing={3} key={question}>
      {header}
      {answerElement}
    </Stack>
  )
}

export default function FAQBody({
  items,
  collapsible = false,
}: {
  items: FaqItem[]
  collapsible?: boolean
}): JSX.Element {
  return (
    <Stack spacing={8}>
      {items.map(item => (
        <FAQItem key={item.question} collapsible={collapsible} item={item} />
      ))}
    </Stack>
  )
}
